/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';

const DealDescription = {
  DEAL_ASSIGNED: (_n?: Notification) => 'A new Deal is assigned to you.',
  DEAL_REMOVED_ASSIGNED: (_n?: Notification) =>
    'A Deal has been unassigned from you.',
  DEAL_UPDATED: (_n?: Notification) =>
    'A Deal assigned to you has been updated.',
};

const DealLogs = {
  DEAL_ASSIGNED: {
    title: 'Deal Assigned',
    description: (_n?: Notification) =>
      DealDescription.DEAL_ASSIGNED(_n as Notification),
    element: ({ actor, meta, referenceId }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/sales/deals/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/sales/deals/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const Deal = useMemo(() => meta?.name ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {DealDescription['DEAL_ASSIGNED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Deal Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={Deal}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  DEAL_REMOVED_ASSIGNED: {
    title: 'Deal Assigned Removed',
    description: (_n?: Notification) =>
      DealDescription.DEAL_REMOVED_ASSIGNED(_n as Notification),
    element: ({ referenceId, meta, actor }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/sales/deals/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/sales/deals/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const Deal = useMemo(() => meta?.name ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {DealDescription['DEAL_REMOVED_ASSIGNED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Deal Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={Deal}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  DEAL_UPDATED: {
    title: 'Deal Updated',
    description: (_n?: Notification) =>
      DealDescription.DEAL_UPDATED(_n as Notification),
    element: ({ referenceId, meta, actor }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/sales/deals/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/sales/deals/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const Deal = useMemo(() => meta?.name ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {DealDescription['DEAL_UPDATED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Deal Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={Deal}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
};

export default DealLogs;
